import instance from 'utils/axios/instance.axios';
import { ADJUSTMENT_COMMENTS } from './_constant';

export const createAdjustmentComment = (data) => instance.post(ADJUSTMENT_COMMENTS.CREATE, data);

export const updateAdjustmentComment = (id, data) =>
  instance.put(ADJUSTMENT_COMMENTS.UPDATE(id), data);

export const getAllAdjustmentComments = (params) =>
  instance.get(ADJUSTMENT_COMMENTS.GET_ALL, { params });

export const getAdjustmentCommentsById = (adjustmentId) =>
  instance.get(ADJUSTMENT_COMMENTS.GET_BY_ID(adjustmentId));
